import tt from "@tomtom-international/web-sdk-maps";
import "@tomtom-international/web-sdk-maps/dist/maps.css";
import { Form } from "antd";
import { useEffect, useState } from "react";
import { roles, tomtomApiKey } from "../../../../utils/constants";
import { onlyRoleMapping } from "../../../../engine/AuthRoute";
import axios from "axios";

export const TomTomMaps = ({ keys, refForm }) => {
  const r = onlyRoleMapping([roles.admin, roles.permanance]);
  const [visible, setVisible] = useState(false);
  const address = Form.useWatch(keys);

  // ---- helpers ----
  const initMap = (lng, lat) => {
    const map = tt.map({
      key: tomtomApiKey,
      container: "map" + address,
      center: [lng, lat],
      zoom: 16,
      interactive: r,
      styleMode: "dark",
      style: {
        map: "2/basic_street-satellite",
        poi: "",
        trafficIncidents: "",
        trafficFlow: "",
      },
      stylesVisibility: {
        map: true,
        poi: false,
        trafficFlow: false,
        trafficIncidents: false,
      },
    });

    const marker = new tt.Marker().setLngLat([lng, lat]).addTo(map);
    setVisible(true);

    return { map, marker };
  };

  const getCoords = async mapStr => {
    const url = `https://api.tomtom.com/search/2/geocode/${encodeURIComponent(
      mapStr,
    )}.json?key=${tomtomApiKey}&limit=1&countrySet=CH`;

    const { data } = await axios.get(url);
    const pos = data?.results?.[0]?.position; // { lat, lon }
    if (pos?.lon != null && pos?.lat != null) {
      return { lng: pos.lon, lat: pos.lat };
    }
    return null;
  };

  useEffect(() => {
    let mapInstance = null;
    let markerInstance = null;
    let cancelled = false;

    if (!refForm?.current || address === undefined) return;

    const values = refForm.current[`_${keys}`]?.find(e => e._id === address);
    let lng = refForm.current.getFieldValue("lng_" + keys);
    let lat = refForm.current.getFieldValue("lat_" + keys);

    const run = async () => {
      try {
        // 1) Priorité aux coords déjà connues
        if (lng != null && lat != null && values !== undefined) {
          const { map, marker } = initMap(lng, lat);
          mapInstance = map;
          markerInstance = marker;
          return;
        }

        let mapsAddressename;

        if (keys === "maps") {
          mapsAddressename = address;
        } else {
          mapsAddressename = values?.maps;
        }

        // 2) Sinon on géocode l'adresse textuelle
        if (mapsAddressename) {
          const pos = await getCoords(mapsAddressename);
          if (!cancelled && pos) {
            const { map, marker } = initMap(pos.lng, pos.lat);
            mapInstance = map;
            markerInstance = marker;
            return;
          }
        }

        // 3) Rien à afficher
        if (!cancelled) setVisible(false);
      } catch (e) {
        console.error(e);
        if (!cancelled) setVisible(false);
      }
    };

    run();

    return () => {
      cancelled = true;
      if (markerInstance) markerInstance.remove();
      if (mapInstance) mapInstance.remove();
    };
  }, [address, refForm, keys]);

  return (
    <div
      key={keys + address}
      id={"map" + address}
      style={{
        width: "100%",
        height: visible ? "300px" : "0",
        maxHeight: "500px",
        transition: "height 160ms ease",
        borderRadius: 6,
        overflow: "hidden",
      }}
    />
  );
};
